export default class GetWorkScopeSpecificationByIdError extends Error {
    constructor(message: string, options?: ErrorOptions) {
        super(message, options);
        this.name = "GetWorkScopeSpecificationByIdError";
    }
}